<template>
  <div class="aside-bar" :style="customStyle">
    <div v-show="!commentVisible" class="list">
      <div
        v-if="detail.id && loginUser.is_super"
        class="aside-item"
        title="编辑"
        @click="handleItem('editor')"
        style="background: #0EC4FF;"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.08 4.33163C15.0408 4.2936 14.9783 4.29408 14.9397 4.33271L12.2899 6.98245L17.3981 11.8287C17.7587 12.1708 17.7737 12.7404 17.4316 13.101C17.0895 13.4616 16.5199 13.4766 16.1593 13.1345L11.0167 8.25569L3.9289 15.3435C3.91015 15.3623 3.89961 15.3877 3.89961 15.4142V22C3.89961 22.0552 3.94438 22.1 3.99961 22.1H13.6694L23.4145 12.5565C23.4547 12.5171 23.4545 12.4524 23.4142 12.4132L15.08 4.33163ZM16.242 22.1L24.6739 13.8425C25.4374 13.0948 25.4343 11.8649 24.6672 11.121L16.3331 3.03941C15.5879 2.31685 14.4008 2.32598 13.6669 3.05992L2.65611 14.0707C2.29979 14.427 2.09961 14.9103 2.09961 15.4142V22C2.09961 23.0493 2.95027 23.9 3.99961 23.9H14.0366H25.0737V22.1H16.242Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="aside-item" @click="onLike">
        <i :class="['wiki-icon', detail.is_like ? 'wiki-icon-detail-like-active' : 'wiki-icon-detail-like']"></i>
        <span>{{ formatCount(detail.like_count) }}</span>
      </div>
      <div class="aside-item" @click="onFavorite">
        <i
          :class="['wiki-icon', detail.is_favorite ? 'wiki-icon-detail-favorite-active' : 'wiki-icon-detail-favorite']"
        ></i>
        <span>{{ formatCount(detail.favorite_count) }}</span>
      </div>
      <div class="aside-item" v-if="detail.id" @click="openComment">
        <i :class="['wiki-icon', 'wiki-icon-detail-comment']"></i>
        <span>{{ formatCount(detail.comment_count) }}</span>
      </div>
      <div class="aside-item" @click="onShare">
        <i :class="['wiki-icon', 'wiki-icon-detail-share']"></i>
        <span>分享</span>
      </div>
    </div>
    <el-dialog
      :title="`评论（${detail.comment_count}）`"
      :visible.sync="commentVisible"
      append-to-body
      width="684px"
      custom-class="comment-dialog"
      top="10vh"
    >
      <div class="dialog-comment-list">
        <DetailComment
          :detail="contentDetail"
          :user="contentDetail.user"
          :list="commentList"
          :pagination="pagination"
          :loadCommentStatus="loadCommentStatus"
          @getCommentList="getCommentList"
          @refresh="refresh"
          @setLoading="setLoading"
        />
      </div>
      <div class="fllow-comment">
        <div class="aside-item" @click="onLike">
          <i :class="['wiki-icon', detail.is_like ? 'wiki-icon-detail-like-active' : 'wiki-icon-detail-like']"></i>
          <span>{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="aside-item" @click="onFavorite">
          <i
            :class="[
              'wiki-icon',
              detail.is_favorite ? 'wiki-icon-detail-favorite-active' : 'wiki-icon-detail-favorite'
            ]"
          ></i>
          <span>{{ formatCount(detail.favorite_count) }}</span>
        </div>
        <div class="aside-item" @click="onShare">
          <i :class="['wiki-icon', 'wiki-icon-detail-share']"></i>
          <span>分享</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import calcMixin from "@/mixins/calcMixin";
import { mapGetters } from "vuex";
import DetailComment from "./detailComment";
import { apiCommentList } from "@/api/commentApi";
// api
import { apiContentLike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";
// plugins
import eventBus from "@/plugins/eventBus";
import { debounce } from "@/plugins/util"

export default {
  name: "fixedShare",
  mixins: [calcMixin],
  components: { DetailComment },
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contentDetail: {},
      commentVisible: false,
      // 评论列表
      commentList: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: ""
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  watch: {
    detail: {
      handler(val) {
        this.contentDetail = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleItem(type) {
      if (type === "editor") {
        this.goEdit();
      }
    },
    goEdit() {
      this.$router.push(
        `/${this.gameInfo.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
      );
    },
    handleScroll() {},
    formatCount(count) {
      if (count >= 1000 && count < 10000) {
        return Math.floor(count / 1000) + "k+";
      } else if (count > 10000) {
        return Math.floor(count / 10000) + "w+";
      }
      return count;
    },
    openComment() {
      this.commentVisible = true;
      this.getCommentList();
    },
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      if (detail) {
        this.$set(this, "contentDetail", detail);
      }
      if (user) {
        this.$set(this.contentDetail, "user", user);
      }
    },
    // 获取评论
    async getCommentList(type) {
      if (this.$route.params.id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.commentList = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      let { id } = this.$route.params;
      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.commentList = this.commentList.concat(res.data);
            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    // 点赞
    onLike:debounce(function () {
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    }),
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      eventBus.$emit("openZSTJShare");
    }
  }
};
</script>
<style lang="less" scoped>
.aside-bar {
  position: fixed;
  bottom: 130px;
  right: 20px;
  .list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}
.aside-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 58px;
  height: 58px;
  color: #aab9bf;
  font-size: 12px;
  background: linear-gradient(to bottom, #2d3344, #343c45);
  border-radius: 30px;
  transition: all ease 0.3s;
  cursor: pointer;
  i {
    font-size: 28px;
  }
}
.fllow-comment {
  position: absolute;
  bottom: 20px;
  right: -70px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/deep/ .comment-dialog {
  border-radius: 16px;
  background: linear-gradient(to bottom, #2d3344, #343c45);
  .el-dialog__header {
    padding: 20px 32px 0;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      right: 32px;
      top: 22px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 22px 32px;
    .detail-comment {
      background-color: transparent;
      padding-top: 0;
    }
    .article-edit-box {
      background-color: transparent;
      padding: 14px 10px;
    }
    .wiki-comment-list {
      background-color: transparent;
    }
    .wiki-comment-list .userAnswer {
      border-bottom: 1px solid rgba(233, 233, 233, 0.04);
      margin-right: 16px;
      .content {
        color: #bebebe;
      }
      .user-replay {
        .user-box .answer {
          color: #ceedfa;
        }
        .replay-content {
          color: #bebebe;
        }
      }
    }
    .article-edit-box {
      color: #bebebe;
      height: initial;
      max-height: 100px;
      border-radius: 4px;
      &:empty:before {
        content: attr(placeholder);
        color: #5b6478;
        font-size: 13px;
      }
    }
    .detail-comment {
      .article-edit-container {
        border: none;
        padding: 0;
        background-color: #20242e;
        .tool-bar {
          border-top: none;
          padding: 0;
          margin: 0;
          padding: 8px 10px;
          height: initial;
          .img-update-btn {
            width: initial;
          }
          .send-btn,
          .cancel-btn {
            padding: 6px 12px;
          }
          .cancel-btn {
            background-color: transparent;
            color: #fff;
          }
        }
        .img-group {
          padding: 10px;
          margin: 0;
        }
      }
    }
    .dialog-comment-list .wiki-detail-comment {
      height: 70vh;
      display: flex;
      flex-direction: column;
      gap: 28px;
      .detail-comment {
        background-color: transparent;
        margin: 0;
        padding: 0;
      }
      .wiki-comment-list {
        flex-grow: 1;
        height: 0;
        background-color: transparent;
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
